import EvidenceDocumentation from "@/features/datablocks/documentation";

const EvidenceDocumentationPage = () => {
  return <EvidenceDocumentation />;
};

export default EvidenceDocumentationPage;
